<!-- 忘记密码 -->
<template>
  <div class="v-reset-password">
    <div class="v-reset-title">
      {{ $t('resetPassword') }}
    </div>
    
    <!-- @blur="regEmail" -->
    <v-input v-if="loginType == 'email'" :labelName="$t('email')" v-model="inputVal.email"></v-input>
    <v-input v-else-if="loginType == 'phone'" :labelName="$t('phone')" v-model="inputVal.phone" @blur="regEmail" max="11"></v-input>
    <v-code
      :labelName="$t('code')"
      v-model="inputVal.code"
      :regText="loginType == 'email' ? inputVal.email : inputVal.phone"
      :reg="loginType == 'email' ? 'email' : 'phone'"
      :seconds="120"
      :placeholder="$t('Please enter your code')"
      @callback="callback"
    ></v-code>
    <v-input
      :labelName="$t('newPassword')"
      v-model="inputVal.password"
      type="password"
    ></v-input>
    <v-input
      :labelName="$t('inputAgain')"
      v-model="inputVal.repassword"
      :placeholder="$t('newPasswordAgain')"
      type="password"
    >
    </v-input>
    <el-button class="v-big-btn" type="primary" @click="submit">{{ $t('confirm') }}</el-button>
    <div class="text-right font-size-12">
      <span class="theme-color pointer" @click="goLogin">{{
        $t('backLogin')
      }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vInput from '@/components/vInput'
import vCode from '@/components/vCodes'
import { sendEmailCode ,setPassWord,checkEmail ,sendPhoneCode} from '@/api/index'
import {setToken,reg} from '@/utils/function'

export default {
  name: 'resetPassword',
  components: {
    vInput,
    vCode
  },
  data() {
    return {
      loginType: localStorage.getItem('loginType'),
      inputVal: {
        phone: '',
        email: '',
        code: '',
        password: '',
        repassword: ''
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'loginAccount'])
  },
  mounted(){
    this.inputVal.email = this.loginAccount
    this.inputVal.phone = this.loginAccount
  },
  methods: {
    goLogin() {
      this.$emit('callback', { type: 'switchComponents', path: 'vLogin' })
    },
    callback(res) {
      var _this = this
      sessionStorage.setItem('codeAwait', '1')
      if (res.type == 'sendCode') {
        var params = {}
        if(this.loginType == 'email') {
          params = {
            email: _this.inputVal.email
          }
          //发送邮件验证码
          sendEmailCode(params).then(res => {
              if(res.data.code==1000){
                setToken(res.headers.authorization);
                _this.$notify({
                    title:_this.$t('tip.success'),
                    message:_this.$t('emailCodeSendTip'),
                    type:'success'
                })
              }
              sessionStorage.setItem('codeAwait', '2')
          }).catch(() => {
              sessionStorage.setItem('codeAwait', '3')
          })
        } else if (this.loginType == 'phone') {
          params = {
            mobile: _this.inputVal.phone
          }
          // 发送短信验证码
          sendPhoneCode(params).then(res => {
            if(res.data.code==1000){
              setToken(res.headers.authorization);
              _this.$notify({
                  title:_this.$t('tip.success'),
                  message:_this.$t('mobileCodeSendTip'),
                  type:'success'
              })
            }
            sessionStorage.setItem('codeAwait', '2')
          }).catch(() => {
              sessionStorage.setItem('codeAwait', '3')
          })
        }
      }
      
    },
    submit(){   
        var _this=this;
        var obj=_this.inputVal;
        if (this.loginType == 'email') {
          if(!obj.email){
            _this.$notify.error({
              message:_this.$t('Please enter your email')
            })
            return ''
          }else if(!reg.email.test(obj.email)){
            _this.$notify.error({
              message:_this.$t('Please enter your correct email address')
            })
            return ''
          }else if(!obj.code){
            _this.$notify.error({
              message:_this.$t('Please enter your verification code')
            })
            return ''
          }else if(!obj.password){
            _this.$notify.error({
              message:_this.$t('Please enter your password')
            })
            return ''
          }else if(!obj.repassword){
            _this.$notify.error({
              message:_this.$t('newPasswordAgain')
            })
            return ''
          }else if(obj.password!=obj.repassword){
            _this.$notify.error({
              message:_this.$t('The two passwords you entered did not match')
            })
            return ''
          }
        } else if (this.loginType == 'phone') {
          if(!obj.phone){
            _this.$notify.error({
              message:_this.$t('Please enter your mobile')
            })
            return ''
          }else if(!reg.chinesePhone.test(obj.phone)){
            _this.$notify.error({
              message:_this.$t('Please enter your correct mobile')
            })
            return ''
          }else if(!obj.code){
            _this.$notify.error({
              message:_this.$t('Please enter your verification code')
            })
            return ''
          }else if(!obj.password){
            _this.$notify.error({
              message:_this.$t('Please enter your password')
            })
            return ''
          }else if(!obj.repassword){
            _this.$notify.error({
              message:_this.$t('newPasswordAgain')
            })
            return ''
          }else if(obj.password!=obj.repassword){
            _this.$notify.error({
              message:_this.$t('The two passwords you entered did not match')
            })
            return ''
          }
        }

        var params = {
            password:_this.$md5(_this.inputVal.password),
            smsCode:_this.inputVal.code
        }
        if(this.loginType == 'email') {
          params.email = _this.inputVal.email
        } else if (this.loginType == 'phone') {
          params.mobile = _this.inputVal.phone;
          params.countryCode = '86';
        }
        window.PC.$RangersEventLoginAndRegister('password_ok', {
            status: this.loginType == 'email' ? 'email' : 'mobile',
            account: this.loginType == 'email' ? _this.inputVal.email : this.inputVal.phone
        })
        setPassWord(params).then(res=>{
          if(res.data.code === 1000){
            this.$notify({
              message: res.data.message,
              type: 'success'
            });
            _this.goLogin();
          }
        })
    },
    regEmail(){
      let _this=this;

      if(this.loginType == 'email') {
        if(!_this.inputVal.email){
          _this.$notify.error({
            message:_this.$t('Please enter your email')
          })
          return ''
        }else if(!reg.email.test(_this.inputVal.email)){
          _this.$notify.error({
            message:_this.$t('Please enter your correct email address')
          })
          return ''
        }
        checkEmail({email:_this.inputVal.email}).then(res=>{
          if(res.data.code==1000&&!res.data.data.repeat){
            _this.$notify.error({
              message:_this.$t('please click the "login/registration" button to register')
            })
            _this.inputVal.email='';
          }
        })
      } else {
        if(!_this.inputVal.phone){
          _this.$notify.error({
            message:_this.$t('Please enter your mobile')
          })
          return ''
        }else if(!reg.chinesePhone.test(_this.inputVal.phone)){
          _this.$notify.error({
            message:_this.$t('Please enter your correct mobile')
          })
          return ''
        }
        // 调用接口
      }
      
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-reset-password{
    width:320px;
    margin:0 auto;
    .v-reset-title{
        margin:32px 0;
        margin-top: 20px;
        font-size:22px;
        line-height: 30px;
    }
    .v-big-btn{
        width:100%;
        margin:24px 0 12px;
    }
}
</style>
